import React, {
  Component
} from 'react';
import NavBar from '../../Components/NavBar/NavBar';
import './AdminLogin.css';
import PageRoute from '../../Components/Utils/PageRoutes'
import Loader from 'react-loader-spinner'
// import 'bootstrap/dist/css/bootstrap.min.css';
import { apiUrl } from "../../Components/Utils/Constants";


class AdminLogin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loading: false,
      errorMessage: ''
    }
  }

  componentDidMount() {
    localStorage.clear();
  }

  onLogin = (e) => {
    e.preventDefault();
    this.setState({
      loading: true
    });
    fetch(`${apiUrl}/admin/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: this.state.email,
          password: this.state.password,
        })
      }).then(response => response.json())
      .then(response => {
        if (response.message === 'success') {
          localStorage.setItem("token", "I am now logged in");
          this.props.history.push(PageRoute.home);
        } else {
          this.setState({
            loading: false,
            errorMessage: 'Invalid Email/Password'
          });
        }
      }).catch(err => {
        console.log(err);
      })



    console.log("click");

    // this.props.history.push(PageRoute.home);
    // localStorage.clear();
  }

  onEmailInput = (e) => {
    console.log(e.target.value);
    this.setState({
      email: e.target.value
    })
  }

  onPassWordInput = (e) => {
    console.log(e.target.value);
    this.setState({
      password: e.target.value
    })
  }

  render() {
    document.title = 'Xtendliving | Admin | Login';
    const {
      loading,
      errorMessage
    } = this.state;

    const body = <div className="center-block">
        <h5 className="col 12 offset-m3">Admin Login</h5>
         <form className="col 12 offset-m3" onSubmit={this.onLogin}>
           <div className="row offset-m3">
             <div className="input-field ">
               <input id="email" type="email" className="validate" onInput={this.onEmailInput}/>
               <label htmlFor="email">Email</label>
             </div>
           </div>
           <div className="row">
             <div className="input-field">
               <input id="password" type="password" className="validate" onInput={this.onPassWordInput} />
               <label htmlFor="password">Password</label>
             </div>
           </div>
           <button className="btn black">Login</button>

         </form>
       </div>
    const load = <div className="center">
      <Loader
           type="TailSpin"
           color="#000000"
           height={50}
           width={50}
        />
    </div>
    return (
      <div>
          <NavBar loggedIn={false}/>

          <div className="container login_container">
            <h5 className="center red-text">{errorMessage}</h5>
            {loading ? load : body}
          </div>

      </div>
    )
  }
}

export default AdminLogin;